import { Dispatch } from 'redux';
import { PrefillClientPayload } from 'api/AuthApi';
import { setYourContactData } from 'handlers/yourContact';
import { setYourBirthDateData } from 'handlers/yourBirthDate';
import { setYourDetailsData } from 'handlers/yourAddress';
import { setYourSSN4 } from 'handlers/yourSSN4';
import {
  YourBirthDateVariable,
  YourContactVariable,
  YourDetailsVariable,
  YourSSN4Variable,
} from 'enums/LoanFormVariables';

export const hydratePrefillIntoRedux = (dispatch: Dispatch, prefill: PrefillClientPayload): void => {
  if (prefill.email) {
    dispatch(setYourContactData({ [YourContactVariable.Email]: prefill.email }));
  }
  if (prefill.dateOfBirth) {
    dispatch(setYourBirthDateData({ [YourBirthDateVariable.DateOfBirth]: prefill.dateOfBirth }));
  }
  dispatch(
    setYourDetailsData({
      [YourDetailsVariable.AddressLine1]: prefill.streetAddress,
      [YourDetailsVariable.AddressLine2]: '',
      [YourDetailsVariable.City]: prefill.city,
      [YourDetailsVariable.ZipCode]: prefill.zipCode,
      [YourDetailsVariable.ArgyleState]: prefill.state,
    }),
  );
  if (prefill.last4SSN) {
    dispatch(setYourSSN4({ [YourSSN4Variable.SSN4]: prefill.last4SSN }));
  }
};
